module.exports = __webpack_public_path__ + "img/img-2.e35b41f3.png";